// import './style.css';

export default function HistoryFavLoader(props: any) {
    return (
        <div>
            {props.type === "history" &&
                <div className="animate-pulse mt-[10px] mb-[30px] h-[20px] hfHeading rounded w-[130px]"></div>
            }
            {Array.from({ length: 6 }).map((_, index) => (
                <div key={index} className="flex items-center mb-[25px] animate-pulse">
                    <div className="hfVideoThumbnail h-[125px] mr-[15px]"></div>
                    <div className="h-[20px] hfTitle rounded w-[35%]"></div>
                </div>
            ))}
        </div>
    );
}
